<template>
  <a-spin :spinning="formOption.busy">
    <a-form :form="form"
            :label-col="{ span: 6 }"
            :wrapper-col="{ span: 12 }"
    >
<!--      <a-form-item label="原密码">-->
<!--        <a-input-password v-decorator="['password', rules.password]"/>-->
<!--      </a-form-item>-->
      <a-form-item label="新密码">
        <a-input-password v-decorator="['newPassword', rules.newPassword]"/>
      </a-form-item>
      <a-form-item label="确认密码">
        <a-input-password v-decorator="['passwordSec',rules.passwordSec]"/>
      </a-form-item>
    </a-form>

    <a-space class="a-form-btn-box">
      <a-button @click="$emit('cancel');">取消</a-button>
      <a-button type="primary" @click="save">提交</a-button>
    </a-space>

  </a-spin>
</template>

<script>
//菜单api
import {dataApi} from '@/services/comm/userManage';
import {mapGetters} from "vuex";


/**
 * 表单组件
 */
export default {
  computed: {
    ...mapGetters('account', ['user']),
  },
  data() {
    return {
      form: this.$form.createForm(this),
      rules: {
        password: {
          rules: [{required: true, message: "请输入原密码"}]
        },
        newPassword: {
          rules: [{required: true, message: "请输入新密码"}]
        },
        passwordSec: {
          rules: [{required: true, message: "请输入确认密码"}]
        },
      },
      // 表单控制变量
      formOption: {
        /**
         * 加载/保存遮罩
         */
        busy: false
      }
    };
  },
  methods: {
    /**
     * 开始加载数据
     * @param rowId 主键值
     */
    loadEntity() {
      this.form.resetFields();//重置表单内容
      this.formOption.busy = false;
    },
    async save() {
      this.formOption.busy = true;
      let entities = {};
      this.form.validateFields((err, values) => {
        if (!err) {//无任何错误 向下执行
          entities = values;
        } else {
          entities = null;
          this.formOption.busy = false;
        }
      });
      if (!entities) {
        return
      }

      if (entities.newPassword !== entities.passwordSec) {
        this.formOption.busy = false;
        this.$message.error('确认密码和新密码不一致');
        return
      }
      //给主键赋值
      entities.userId = this.user.userId;
      await dataApi.adminUpdatePassword(entities).then(() => {
        this.$message.success('修改成功');
        setTimeout(()=>{
          this.$emit('save');
        },1500)
      }).catch(e => {
        this.$message.error(e.msg)
      }).finally(() => {
        this.formOption.busy = false;
      });

    }
  },
};
</script>

<style scoped lang="stylus">

</style>